<template>
  <div>
    <Navbar />
    <b-overlay v-if="!Loading">
      <div
        class="container"
        style="min-height: calc(100vh - 335px); margin-top: 100px"
      >
        <b-row>
          <b-col class="text-left">
            <h2
              @click="$router.push({ name: 'Application' })"
              style="cursor: pointer"
            >
              <b-icon-chevron-left></b-icon-chevron-left>
              {{ $t("RegistrationOfAthlete") }}
            </h2>
          </b-col>
        </b-row>
        <b-row class="mt-3 mb-3">
          <b-col sm="12" md="3" lg="3">
            <div class="image-container">
                    <b-img
                      thumbnail
                      fluid
                      style="width: 200px; height: 220px"
                      class="thumbnail ml-auto mr-auto"
                      :src="
                        !!RegistrationOfAthlete.photo.attachmentfileid &&
                        Object.keys(RegistrationOfAthlete.photo).length > 0
                          ? axios.defaults.baseURL +
                            '/' +
                            `FileManage/Get?id=${RegistrationOfAthlete.photo.attachmentfileid}`
                          : 'data:image/jpg;base64,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'
                      "
                    />
            </div>
          </b-col>
          <b-col  sm="12" md="9" lg="9">
            <b-row class="mt-3 mb-3">
          <b-col sm="12" md="6">
            <custom-label
              :label="$t('familyname')"
              :content="RegistrationOfAthlete.familyname"
            ></custom-label>
          </b-col>
          <b-col sm="12" md="6">
            <custom-label
              :label="$t('firstname')"
              :content="RegistrationOfAthlete.firstname"
            ></custom-label>
          </b-col>
          <b-col sm="12" md="6" class="mt-2">
            <custom-label
              :label="$t('lastname')"
              :content="RegistrationOfAthlete.lastname"
            ></custom-label>
          </b-col>
          <b-col sm="12" md="6" class="mt-2">
            <custom-label
              :label="$t('documentseries')"
              :content="RegistrationOfAthlete.documentseries"
            ></custom-label>
          </b-col>
          <b-col sm="12" md="4" class="mt-2">
            <custom-label
              :label="$t('documentnumber')"
              :content="RegistrationOfAthlete.documentnumber"
            ></custom-label>
          </b-col>
          <b-col sm="12" md="4" class="mt-2">
            <custom-label
              :label="$t('dateofbirth')"
              :content="RegistrationOfAthlete.dateofbirth"
            ></custom-label>
          </b-col>
          <b-col sm="12" md="4" class="mt-2">
            <custom-label
              :label="$t('gender')"
              :content="RegistrationOfAthlete.gendername"
            ></custom-label>
            <!-- :disabled="canchange" -->
          </b-col>
        </b-row>
          </b-col>

        </b-row>
        <b-row class="mt-2" >
          <b-col sm="12" md="4" lg="4" >
                  <custom-label
                    :label="$t('initiativtype')"
                    :content="RegistrationOfAthlete.initiativtypename"
                  ></custom-label>
                </b-col>
                <b-col sm="12" md="4" lg="4" v-if="RegistrationOfAthlete.initiativtypeid == 1">
                  <custom-label
                    :label="$t('oblast')"
                    :content="RegistrationOfAthlete.oblastname"
                  ></custom-label>
                </b-col>
                <b-col sm="12" md="4" lg="4" v-if="RegistrationOfAthlete.initiativtypeid == 1">
                  <custom-label
                    :label="$t('region')"
                    :content="RegistrationOfAthlete.regionname"
                  ></custom-label>
                </b-col>
          </b-row>
        <b-row class="mt-2" v-if="RegistrationOfAthlete.initiativtypeid == 2">
                <b-col sm="12" md="12" lg="12" class="mt-3">
                  <h5>{{$t('EduSchoolInfoTable')}}</h5>
                </b-col>
                <b-col sm="12" md="6" lg="6" >
                  <custom-label
                    :label="$t('oblast')"
                    :content="RegistrationOfAthlete.EduSchoolInfo.oblastname"
                  ></custom-label>
                </b-col>
                <b-col sm="12" md="6" lg="6" >
                  <custom-label
                    :label="$t('region')"
                    :content="RegistrationOfAthlete.EduSchoolInfo.regionname"
                  ></custom-label>
                </b-col>
                <b-col sm="12" md="6" lg="8" class="mt-2">
                  <custom-label
                    :label="$t('school')"
                    :content="RegistrationOfAthlete.EduSchoolInfo.organizationname"
                  ></custom-label>
                </b-col>
                <b-col sm="12" md="6" lg="4" class="mt-2">
                  <custom-label
                    :label="$t('schoolgrade')"
                    :content="RegistrationOfAthlete.EduSchoolInfo.schoolgradename"
                  ></custom-label>
                </b-col>
              </b-row>
              <b-row class="mt-2" v-if="RegistrationOfAthlete.initiativtypeid == 3">
                <b-col sm="12" md="6" lg="6" >
                  <custom-label
                    :label="$t('oblast')"
                    :content="RegistrationOfAthlete.OrgProfEduInfo.oblastname"
                  ></custom-label>
                </b-col>
                <b-col sm="12" md="6" lg="6" >
                  <custom-label
                    :label="$t('region')"
                    :content="RegistrationOfAthlete.OrgProfEduInfo.regionname"
                  ></custom-label>
                </b-col>
                <b-col sm="12" md="8" lg="8" class="mt-2">
                  <custom-label
                    :label="$t('proftalim')"
                    :content="RegistrationOfAthlete.OrgProfEduInfo.organizationname"
                  ></custom-label>
                </b-col>
              </b-row>
        <!-- v-if="isView" -->
        <b-row class="mt-2 mb-3">
          <b-col sm="12" md="4">
            <custom-label
              :label="$t('agecategory')"
              :content="RegistrationOfAthlete.agecategoryname"
            ></custom-label>
          </b-col>
          <b-col sm="12" md="4">
            <custom-label
              :label="$t('sporttypecategory')"
              :content="RegistrationOfAthlete.sporttypecategoryname"
            ></custom-label>
          </b-col>
          <b-col sm="12" md="4">
            <custom-label
              :label="$t('sporttype1')"
              :content="RegistrationOfAthlete.sporttypename"
            ></custom-label>
          </b-col>
          <b-col sm="12" md="4"></b-col>
          <!-- <b-col sm="12" md="8">
            <custom-label
              :label="$t('detail')"
              :content="RegistrationOfAthlete.detail"
            ></custom-label>
          </b-col> -->
        </b-row>
      </div>
    </b-overlay>
    <div
      v-if="Loading"
      style="width: 100%; height: calc(100vh - 335px)"
      class="d-flex align-items-center justify-content-center"
    >
      <b-spinner></b-spinner>
    </div>
    <Footer />
  </div>
</template>

<script>
import Navbar from "../components/navbar.vue";
import Footer from "../components/footer.vue";
import {
  BIconPlus,
  BIconPaperclip,
  BIconTrash,
  BIconCheck2Circle,
  BIconChevronLeft,
  BIconX,
  BIconExclamationTriangleFill,
  BIconCheckCircleFill,
  BIconSearch,
  BOverlay,
  BImg
} from "bootstrap-vue";
import CustomSelect from "./components/CustomSelect.vue";
import CustomInput from "./components/CustomInput.vue";
import CustomDatePicker from "./components/CustomDatepicker.vue";
import CustomLabel from "./components/CustomLabel.vue";
import RegistrationOfAthleteService from "../services/registrationofathlete.service";
import axios from "axios";
export default {
  components: {
    Navbar,
    BIconPlus,
    BIconSearch,
    BOverlay,
    CustomSelect,
    CustomInput,
    CustomDatePicker,
    CustomLabel,
    BIconPaperclip,
    BIconTrash,
    Footer,
    BIconCheck2Circle,
    BIconChevronLeft,
    BIconX,
    BIconExclamationTriangleFill,
    BIconCheckCircleFill,
    BImg,
  },
  data() {
    return {
      axios,
      RegistrationOfAthlete: {},
      lang: localStorage.getItem("locale") || "uz_latn",
      SearchLoading: false,
      SaveLoading: false,
      lang: localStorage.getItem("locale"),
      Loading: false,
    };
  },
  created() {
    this.Loading = true;
    RegistrationOfAthleteService.Get(this.$route.params.id)
      .then((res) => {
        this.RegistrationOfAthlete = res.data;
        this.Loading = false;
      })
      .catch((error) => {
        this.makeToast(error.response.data.error, "error");
      });
  },
  methods: {
    makeToast(message, type) {
      this.$toast.open({
        message: message,
        type: type,
        duration: 5000,
        dismissible: true,
      });
    },
    BindValue(data) {
      this.filter.dateofbirth = data;
    },
  },
};
</script>

<style lang="scss">
.application-modal {
  .modal-xl {
    min-width: 1300px !important;
  }
}
</style>
